import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ImportGlyph = /*#__PURE__*/createElement("g", {
  id: "import"
}, /*#__PURE__*/createElement("path", {
  d: "M34.2 40l7.2 6.8c.1.1.3.2.5.3.2.1.3.1.5.1s.4 0 .5-.1c.2-.1.3-.2.5-.3l7.2-6.8c.6-.6.6-1.5.1-2.1-.6-.6-1.5-.6-2.1-.1l-4.7 4.4V16.6c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5v25.6l-4.7-4.4c-.3-.3-.7-.4-1-.4-.4 0-.8.2-1.1.5-.5.6-.5 1.5.1 2.1z"
}), /*#__PURE__*/createElement("path", {
  d: "M62.4 68.9H21.6c-2.3 0-4.2-1.8-4.2-4.1V34c0-2.2 1.9-4.1 4.2-4.1h10.9c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5H21.6c-.7 0-1.2.5-1.2 1.1v30.8c0 .6.5 1.1 1.2 1.1h40.7c.7 0 1.2-.5 1.2-1.1V34c0-.6-.5-1.1-1.2-1.1H51.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h10.9c2.3 0 4.2 1.8 4.2 4.1v30.8c0 2.3-1.9 4.1-4.2 4.1z"
}));
const Import = createSvg({
  name: 'import',
  path: ImportGlyph
});

export default Import;
export { ImportGlyph };
